module.exports = __webpack_public_path__ + "img/iphoneApp.1acd3b85.png";